import { render } from "./CreationRead.vue?vue&type=template&id=da494c4a&scoped=true"
import script from "./CreationRead.vue?vue&type=script&lang=js"
export * from "./CreationRead.vue?vue&type=script&lang=js"

import "./CreationRead.vue?vue&type=style&index=0&id=da494c4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da494c4a"]])

export default __exports__